// Layered Canadian mountain silhouette SVG for section footers/headers.
export default function MountainSilhouette({ className = "" }) {
  return (
    <svg
      viewBox="0 0 1440 260"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      className={className}
      aria-hidden="true"
      data-testid="mountain-silhouette"
    >
      {/* Distant peaks - lightest */}
      <path
        d="M0 200 L110 130 L200 170 L310 90 L420 150 L520 100 L640 160 L760 110 L860 155 L970 100 L1080 150 L1200 105 L1310 155 L1440 120 L1440 260 L0 260 Z"
        fill="#E7EFF6"
      />
      {/* Mid peaks */}
      <path
        d="M0 230 L90 175 L180 210 L280 150 L380 200 L490 140 L610 205 L720 165 L830 210 L940 155 L1060 210 L1180 160 L1290 205 L1400 170 L1440 195 L1440 260 L0 260 Z"
        fill="#C7D6E4"
      />
      {/* Foreground with pine hint */}
      <path
        d="M0 260 L0 235 L70 215 L150 240 L240 210 L340 245 L440 220 L560 250 L680 225 L800 245 L920 220 L1040 250 L1160 220 L1280 250 L1400 220 L1440 240 L1440 260 Z"
        fill="#1F4A3A"
        fillOpacity="0.9"
      />
      {/* Tiny pine trees — stable keys via x coord */}
      {[120, 260, 420, 610, 780, 940, 1120, 1310].map((x, i) => (
        <g key={`pine-${x}`} transform={`translate(${x} ${228 + (i % 2) * 6})`}>
          <path d="M0 12 L6 -6 L12 12 Z" fill="#0E2A20" />
          <rect x="5" y="12" width="2" height="4" fill="#0E2A20" />
        </g>
      ))}
    </svg>
  );
}
